import { BaseFetch } from "../main-model";
export default class ExportPP1Model extends BaseFetch {
  getExportPP1By = (data) =>
    this.authFetch({
      url: "export-pp1/getExportPP1By",
      method: "POST",
      body: JSON.stringify(data),
    });
    getGradeStudentBy = (data) =>
    this.authFetch({
      url: "export-pp1/getGradeStudentBy",
      method: "POST",
      body: JSON.stringify(data),
    });
    updateExportStudentStatusBy = (data) =>
    this.authFetch({
      url: "export-pp1/updateExportStudentStatusBy",
      method: "POST",
      body: JSON.stringify(data),
    });
    getReadAnalysisAndCharacteristics = (data) =>
    this.authFetch({
      url: "export-pp1/getReadAnalysisAndCharacteristics",
      method: "POST",
      body: JSON.stringify(data),
    });
    getCheckCreditCurriculumby = (data) =>
    this.authFetch({
      url: "export-pp1/getCheckCreditCurriculumby",
      method: "POST",
      body: JSON.stringify(data),
    });
    
}
